import type { FieldTypesFor } from "./types";


export type Interface<T> = { [K in keyof T]: T[K] };

export interface InterfaceRef<T = any>
{
    readonly name: string;
    base?: InterfaceRef;
    extensions?: Record<string, InterfaceRef>;
    fields?: FieldTypesFor<T>;
}

export namespace InterfaceRef
{
    export function define<T>(name: string, fields: FieldTypesFor<T>): InterfaceDefinition<T>;
    export function define<T>(name: string, fields: () => FieldTypesFor<T>): InterfaceDefinition<T>;
    export function define<T>(name: string, fields: FieldTypesFor<T> | (() => FieldTypesFor<T>)): InterfaceDefinition<T>
    {
        const interfaceRef: InterfaceRef<T> = { name };

        if (typeof fields == "object")
            interfaceRef.fields = fields;

        if (typeof fields == "function")
        {
            let resolved: FieldTypesFor<T>;
            Object.defineProperty(
                interfaceRef,
                "fields",
                {
                    get:
                        () =>
                        {
                            return resolved ??= fields();
                        },
                    enumerable: true
                }
            );
        }

        return interfaceRef as InterfaceDefinition<T>;
    }

    export function isInterfaceRef(value: unknown): value is InterfaceRef
    {
        if (!value)
            return false;

        if (typeof value != "object" && typeof value != "function")
            return false;

        return (
            typeof (value as InterfaceRef).name == "string" &&
            typeof (value as InterfaceRef).fields == "object"
        );
    }
}


export interface InterfaceDefinition<T = any> extends InterfaceRef<T>
{
    fields: FieldTypesFor<T>;
}
